import { render, staticRenderFns } from "./TeamAnalytics.vue?vue&type=template&id=5f04349e&"
import script from "./TeamAnalytics.vue?vue&type=script&lang=js&"
export * from "./TeamAnalytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports